import gql from 'graphql-tag'

export const GET_ORDER_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
    $status: OrderStatusType
  ) {
    getOrderPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
        status: $status
      }
    ) {
      hasMore
      total
      items {
        id
        uid
        client {
          fullName
          telNumber
          email
        }
        clientAnonymous {
          fullName
          telNumber
        }
        paymentType
        totalComputed {
          totalPrice
        }
        paymentComputed {
          amount
        }
        currencyObj {
          left
          symbol
          title
        }
        status
        delivery
        deliveryPrice
        createdAt
        reasonEn
        reasonKg
        reasonRu
      }
    }
  }
`;

export const GET_ORDER_PAYMENTS_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $orderId: Int!
  ) {
    getOrderPaymentsPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        orderId: $orderId
      }
    ) {
      hasMore
      total
      items {
        id
        paymentType
        amount
        createdAt
      }
    }
  }
`;

export const GET_ORDER_PAYMENT = gql`
  query (
    $id: Int!
  ) {
    getOrderPayment (
      id: $id
    ) {
      id
      paymentType
      amount
    }
  }
`;

export const GET_ORDER_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getOrder (
      data: {
        id: $id
        joins: [ITEMS, PRODUCT, BRANCH, CLIENT, COUPON, PAYMENT_COMPUTED, CURRENCY, TOTAL_PRICE]
      }
    ) {
      id
      items {
        id
        product {
          id
          titleEn
          titleRu
          titleKg
          category {
            titleEn
            titleRu
            titleKg
          }
          brand {
            titleEn
            titleRu
            titleKg
          }
          coverImage
        }
        quantity
        price
        discount
        discountType
      }
      branch {
        id
        titleEn
        titleRu
        titleKg
        addressEn
        addressRu
        addressKg
      }
      paymentType
      paymentComputed {
        amount
      }
      client {
        id
        fullName
        telNumber
        email
        image
        clientType
      }
      clientAnonymous {
        id
        fullName
        telNumber
      }
      comment
      notes
      reasonKg
      reasonRu
      reasonEn
      coupon {
        id
        titleEn
        titleRu
        titleKg
      }
      createdAt
      currencyObj {
        title
        symbol
      }
      delivery
      deliveryPrice
      deliveryAddress
      totalComputed {
        baseTotalPrice
        totalPrice
        count
        totalQuantity
      }
      status
      uid
    }
  }
`;

export const GET_ORDER_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getOrder (
      data: {
        id: $id
        joins: [CLIENT, CURRENCY]
      }
    ) {
      id
      branchId
      paymentType
      client {
        id
        fullName
        address
        telNumber
        email
        image
      }
      clientAnonymous {
        id
        fullName
        telNumber
      }
      comment
      createdAt
      delivery
      deliveryPrice
      deliveryAddress
      currencyObj {
        symbol
      }
      uid
    }
    getAllBranches {
      id
      titleEn
      titleRu
      titleKg
      addressEn
      addressRu
      addressKg
    }
  }
`;

export const GET_ORDER_UID_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getOrder (
      data: {
        id: $id
        joins: []
      }
    ) {
      id
      uid
    }
  }
`;

export const GET_ORDER_ITEMS_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $orderId: Int!
  ) {
    getOrderItemsPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        orderId: $orderId
      }
    ) {
      hasMore
      total
      items {
        id
        product {
          titleRu
          titleKg
          titleEn
          coverImage
        }
        quantity
        price
        discount
        createdAt
      }
    }
  }
`;

export const GET_ORDER_ITEM = gql`
  query (
    $id: Int!
  ) {
    getOrderItem (
      id: $id
    ) {
      id
      productId
      quantity
      price
      discountType
      discount
    }
  }
`;
